import { Navigate, Route } from 'react-router-dom';

import { PartnerBirthDatePageLazy } from '../pages/ui/partner-birthdate/partner-birthdate.lazy';
import { PartnerBirthPlacePageLazy } from '../pages/ui/partner-birthplace/partner-birthplace.lazy';
import { PartnerBirthTimePageLazy } from '../pages/ui/partner-birthtime/partner-birthtime.lazy';
import { PartnerNamePageLazy } from '../pages/ui/partner-name/partner-name.lazy';
import { PartnerZodiacPageLazy } from '../pages/ui/partner-zodiac/partner-zodiac.lazy';
import { ResultPageLazy } from '../pages/ui/result/result.lazy';
import { YourBirthDatePageLazy } from '../pages/ui/your-birthdate/you-birthdate.lazy';
import { YourBirthPlacePageLazy } from '../pages/ui/your-birthplace/your-birthplace.lazy';
import { YourBirthtimePageLazy } from '../pages/ui/your-birthtime/your-birthtime.lazy';
import { YourGenderPageLazy } from '../pages/ui/your-gender/your-gender.lazy';
import { YourNameLazy } from '../pages/ui/your-name/your-name.lazy';
import { ZodiacPageLazy } from '../pages/ui/zodiac/zodiac.lazy';

export const Q_CompatibilityShortPaths = {
  YourName: () => 'your_name',
  Birthdate: () => 'your_birthdate',
  Birthplace: () => 'your_birthplace',
  Birthtime: () => 'your_birthtime',
  Gender: () => 'gender',
  Zodiac: () => 'your_zodiac',
  PartnerName: () => 'partner_name',
  PartnerBirthdate: () => 'partner_birthdate',
  PartnerBirthPlace: () => 'partner_birthplace',
  PartnerBirthTime: () => 'partner_birthtime',
  PartnerZodiac: () => 'partner_zodiac',
  Result: () => 'result',
} as const;

const routesConfig = [
  { path: '', element: <Navigate to={Q_CompatibilityShortPaths.YourName()} /> },
  { path: Q_CompatibilityShortPaths.YourName(), element: <YourNameLazy /> },
  { path: Q_CompatibilityShortPaths.Birthdate(), element: <YourBirthDatePageLazy /> },
  { path: Q_CompatibilityShortPaths.Birthplace(), element: <YourBirthPlacePageLazy /> },
  { path: Q_CompatibilityShortPaths.Birthtime(), element: <YourBirthtimePageLazy /> },
  { path: Q_CompatibilityShortPaths.Gender(), element: <YourGenderPageLazy /> },
  { path: Q_CompatibilityShortPaths.Zodiac(), element: <ZodiacPageLazy /> },
  { path: Q_CompatibilityShortPaths.PartnerName(), element: <PartnerNamePageLazy /> },
  { path: Q_CompatibilityShortPaths.PartnerBirthdate(), element: <PartnerBirthDatePageLazy /> },
  { path: Q_CompatibilityShortPaths.PartnerBirthPlace(), element: <PartnerBirthPlacePageLazy /> },
  { path: Q_CompatibilityShortPaths.PartnerBirthTime(), element: <PartnerBirthTimePageLazy /> },
  { path: Q_CompatibilityShortPaths.PartnerZodiac(), element: <PartnerZodiacPageLazy /> },
  { path: Q_CompatibilityShortPaths.Result(), element: <ResultPageLazy /> },
];

export const q_CompatibilityShortRoutes = routesConfig.map((route, index) => (
  <Route key={route.path || index} path={route.path} element={route.element} />
));
